import React from 'react';
import { Shield, Home, Users, ThumbsUp } from 'lucide-react';
import { AnimateOnScroll } from './AnimateOnScroll';
export function StatsSection() {
  const stats = [{
    value: '40+',
    label: 'Years of Experience',
    icon: <Shield className="h-8 w-8" data-id="element-341" />
  }, {
    value: '3,000+',
    label: 'Properties Managed',
    icon: <Home className="h-8 w-8" data-id="element-342" />
  }, {
    value: '10,000+',
    label: 'Happy Residents',
    icon: <Users className="h-8 w-8" data-id="element-343" />
  }, {
    value: '98%',
    label: 'Owner Satisfaction',
    icon: <ThumbsUp className="h-8 w-8" data-id="element-344" />
  }];
  return <section className="relative w-full py-20 overflow-hidden" data-id="element-345">
      {/* Background image with blue overlay */}
      <div className="absolute inset-0 z-0" data-id="element-346">
        <img src="https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=1920&q=80" alt="" className="w-full h-full object-cover" data-id="element-347" />
        <div className="absolute inset-0 bg-[oklch(0.25_0.12_250/0.92)]" data-id="element-348" />
      </div>

      <div className="relative z-10 container mx-auto px-4" data-id="element-349">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12" data-id="element-350">
          {stats.map((stat, index) => <AnimateOnScroll key={index} delay={index * 0.12} data-id="element-351">
              <div className="flex flex-col items-center text-center text-white" data-id="element-352">
                <div className="mb-4 p-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/10" data-id="element-353">
                  {stat.icon}
                </div>
                <span className="font-heading text-4xl md:text-5xl font-medium mb-1 text-white" data-id="element-354">
                  {stat.value}
                </span>
                <span className="text-sm md:text-base font-medium text-white/80" data-id="element-355">
                  {stat.label}
                </span>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}